import { inject, Injectable } from '@angular/core';
import { ToastController } from '@ionic/angular/standalone';

/** UI フィードバック用のトースト。Store / コンポーネントから inject して利用する。 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly toastController = inject(ToastController);

  /** エラーメッセージをトーストで表示する（duration で自動で閉じる） */
  async showError(message: string, durationMs = 4000): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration: durationMs,
      position: 'bottom',
      color: 'danger',
    });
    await toast.present();
  }

  /** 成功メッセージをトーストで表示する（duration で自動で閉じる） */
  async showSuccess(message: string, durationMs = 3000): Promise<void> {
    const toast = await this.toastController.create({
      message,
      duration: durationMs,
      position: 'bottom',
      color: 'primary',
    });
    await toast.present();
  }
}
